module.exports = __webpack_public_path__ + "img/agent_1.1586fef4.png";